export default "__VITE_ASSET__aa54d2d5__"